import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { PriorAuthDetail } from "../../Table/TableQueryColumn";

const initialState = {
    data: {
        MpaMemberId: '',
        MPACarrier: '',
        MPAAccount: '',
        MPAGroup: '',
        MPAPriorAuthorizationNumber: '',
        totalCount: 0,
        page: 0,
        pageSize: 50,
        sortOrder: "asc",
        columnName: "HighDollarOr",
        collectionName: "Prior Auth"
    },
    dataAll: "",
    search: true,
    error: false,
    isSearchClicked: false,
    searchTriggered: true,
    loading: false,
    clear: false,
    showAll: false,
    inputError: {
        MPACarrier: false,
        MpaMemberId: false,
        MPAGroup: false,
        MPAPriorAuthorizationNumber: false
    }
}

export const getPriorAuthData = createAsyncThunk('data/getPriorAuthData',
    async (data, { rejectWithValue }) => {
        try {
            let queryPriorAuth =
                `query GetPriorAuthDetails{
                    GetPriorAuthDetails(
                pageNumber:${data.page + 1},
                pageSize:${data.pageSize},
                sortOrder:"${data.sortOrder}",
                columnName:"${data.columnName}",
                collectionName:"Prior Auth",
                isDownload:false,
                ${data.MPACarrier ? `,carrier: "${data.MPACarrier}"` : ""}
                ${data.MpaMemberId ? `,memberid: "${data.MpaMemberId}"` : ""}
                ${data.MPAPriorAuthorizationNumber ? `,panumber: "${data.MPAPriorAuthorizationNumber}"` : ""}
                ${data.MPAGroup ? `,group: "${data.MPAGroup}"` : ""}
                `;

            queryPriorAuth += PriorAuthDetail

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryPriorAuth, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

export const getPriorAuthDownloadAll = createAsyncThunk('data/getPriorAuthDownloadAll',
    async (data, { rejectWithValue }) => {
        try {
            let queryPriorAuthAll =
                `query GetPriorAuthDetails{
                    GetPriorAuthDetails(
                    collectionName:"Prior Auth",
                    isDownload:true,
                ${data.MPACarrier ? `,carrier: "${data.MPACarrier}"` : ""}
                ${data.MpaMemberId ? `,memberid: "${data.MpaMemberId}"` : ""}
                ${data.MPAPriorAuthorizationNumber ? `,panumber: "${data.MPAPriorAuthorizationNumber}"` : ""}
                ${data.MPAGroup ? `,group: "${data.MPAGroup}"` : ""}
                `;

            queryPriorAuthAll += PriorAuthDetail

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryPriorAuthAll, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const priorAuthSlice = createSlice({
    name: 'priorAuth',
    initialState,
    reducers: {
        currentData: (state, action) => {
            state.data = action.payload
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.search = true;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        resetData: (state) => {
            state.data = initialState.data;
            state.search = false;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        updateSearch: (state, action) => {
            state.search = action.payload;
        },
        searchClicked: (state, action) => {
            state.isSearchClicked = action.payload;
            state.error = initialState.error;
        },
        clearTable: (state, action) => {
            state.isSearchClicked = action.payload;
        },
        searchTriggered: (state, action) => {
            state.searchTriggered = action.payload;
        },
        updateInputError: (state, action) => {
            state.inputError = action.payload
        },
        resetError: (state, action) => {
            state.inputError = initialState.inputError;
        },
        resetToaster: (state, action) => {
            state.error = initialState.error;
        },
        showAll: (state, action) => {
            state.showAll = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPriorAuthData.pending, (state) => {
                //state.loading = true;
                state.error = false;
            })
            .addCase(getPriorAuthData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.totalCount = response.data.data.GetPriorAuthDetails.totalCount;
                state.data.tableData = response.data.data.GetPriorAuthDetails.data;
            })
            .addCase(getPriorAuthData.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(getPriorAuthDownloadAll.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getPriorAuthDownloadAll.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.tableData = response.data.data.GetPriorAuthDetails.data;
            })
            .addCase(getPriorAuthDownloadAll.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
    }
})

export const { currentData, clearData, updateSearch, searchClicked, clearTable,
    searchTriggered, updateInputError, resetError, resetToaster, showAll } = priorAuthSlice.actions;
export default priorAuthSlice.reducer